/**
 * @overview a crude wrapper around ReactRouterLink so that we can properly handle full urls (react-router doesn't)
 */

import React from 'react'
import PropTypes from 'prop-types'
import hrefType from 'href-type'
import { Link as ReactRouterLink } from 'react-router'
import isSameOrigin from 'lib/is-same-origin'

class RouterAwareLink extends React.PureComponent {
  static propTypes = {
    /** Whether or not external (different origin) links should be opened in a new tab */
    openExternalInNewTab: PropTypes.bool,
    /** The target location of the link */
    to: PropTypes.string.isRequired
  }

  static defaultProps = {
    openExternalInNewTab: false
  }

  render() {
    const { openExternalInNewTab, to, ...props } = this.props
    const type = hrefType(to)

    if (!type) {
      return <span {...props} />
    }

    // Optionally, open links in new windows/tabs when the origin doesn't match the current location
    if (openExternalInNewTab && !isSameOrigin(to, window.location.href)) {
      props.rel = 'external'
      props.target = '_blank'
    }

    // Only use react-router links for absolute *paths* (not full urls)
    if (type === 'rooted') {
      return <ReactRouterLink to={to} {...props} />
    }

    // Use anchor tag for full urls (`sms:`, `tel:`, `mailto:`, `http(s)?:`, etc.)
    return <a href={to} {...props} />
  }
}

export default RouterAwareLink
